import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M8 5H21V7H8V5ZM3 4.5H6V7.5H3V4.5ZM3 10.5H6V13.5H3V10.5ZM3 16.5H6V19.5H3V16.5ZM8 11H21V13H8V11ZM8 17H21V19H8V17Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ListChecklist"
);
